import { useCallback } from 'react';

import { getAuthHeaders } from '@/services/AuthClientService';

export const useAuthHeaders = () => {
  return useCallback(() => getAuthHeaders(), []);
};
